import { ResultsMode } from 'interfaces/experimentResults';
import { ResultsExportContext } from './useResultsExportContext';

// Workflow exports name their cohort explicitly: the whole study. Dataset selections, filters and slide mode
// that may be present in the URL belong to the Dataset tab and are not part of a Workflow export. The results
// source is the one chosen in the Workflow export dialog, not the Workflow tab's own mode.
export const toWorkflowResultsExportContext = (
  context: ResultsExportContext,
  source: { resultsMode: ResultsMode; orchestrationId?: string }
): ResultsExportContext => {
  const { resultsMode, orchestrationId } = source;
  const studyScope = {
    studyId: context.studyId,
    // The backend resolves the study through this lab; without it an internal user is scoped to their own lab.
    labId: context.labId,
    resultsMode,
    filters: {
      studyId: context.studyId,
      ...(orchestrationId && { orchestrationId }),
    },
  };
  return {
    ...context,
    resultsMode,
    orchestrationId,
    isSlidesMode: false,
    hasSpecificSelections: false,
    hasIntermediateResultsSelection: false,
    areFiltersAppliedExceptStudy: false,
    casesParamsWithoutPaginationAndSorting: studyScope,
    casesParamsWithoutSelections: studyScope,
  };
};
